import { Box, BoxProps, useTheme } from '@mui/material';

import { US_LETTER_SCALE_WIDTH_PX } from '@/modules/presentation/PresentationSlide/PresentationSlide.constants';
import { COLORS } from '@/styles/tokens/colors';

export const PRESENTATION_SLIDE_WIDTH = `min(95%, max(${US_LETTER_SCALE_WIDTH_PX}px, 80%))`;

export function PresentationSlideWrapper({ sx = {}, ...otherProps }: BoxProps) {
  const theme = useTheme();
  return (
    <Box
      data-presentation-slide-wrapper
      sx={{
        border: `solid 1px ${COLORS.NEUTRAL_GRAY[100]}`,
        backgroundColor: 'white',
        boxShadow: theme.palette.shadows.lg,
        // Grow to 80% of the container on large screens, but never below
        // native size (or the prior 95% cap on small screens).
        width: PRESENTATION_SLIDE_WIDTH,
        pointerEvents: 'none',
        ...sx,
      }}
      {...otherProps}
    />
  );
}
